module.exports = __webpack_public_path__ + "img/hand-point-left.95ce2fdf.svg";